export const COMP_RAFFLE_TYPE = 'raffle'
export const COMP_PROMO_TYPE = 'promo'
